<div class="filters-container">
    <dx-select-box
            [value]="selectedDeviceId"
            [dataSource]="devices"
            width="35%"
            displayExpr="name"
            valueExpr="id"
            stylingMode="underlined"
            [showClearButton]="true"
            [placeholder]="'Devices.Device' | i18next"
            (onSelectionChanged)="onDeviceChange($event.selectedItem?.id || null)">
    </dx-select-box>
    <dx-select-box
            [value]="selectedStatus"
            [dataSource]="statusOptions"
            width="35%"
            displayExpr="label"
            valueExpr="value"
            stylingMode="underlined"
            [showClearButton]="true"
            [placeholder]="'General.State' | i18next"
            (onSelectionChanged)="onStatusChange($event.selectedItem?.value || null)">
    </dx-select-box>
    <dx-date-box
            type="date"
            width="25%"
            [showClearButton]="true"
            [placeholder]="'General.Always' | i18next"
            [inputAttr]="{ 'aria-label': 'Date' }"
            (onValueChanged)="onDateChange($event.value)"
    >
    </dx-date-box>
</div>

